import React from 'react';
import { NoahMascot } from './NoahMascot';

/** Pantalla vacía con la mascota de Noah. */
export const EmptyState = ({
  mood = 'empty',
  title,
  description,
  action,
  size = 150,
  compact = false,
  testId = 'empty-state',
}) => (
  <div
    data-testid={testId}
    className={`flex flex-col items-center justify-center text-center ${compact ? 'py-6 gap-2' : 'py-12 gap-3'}`}
  >
    <NoahMascot mood={mood} size={compact ? Math.min(size, 96) : size} />
    {title && <p className="text-base font-semibold text-foreground">{title}</p>}
    {description && <p className="text-sm text-muted-foreground max-w-sm">{description}</p>}
    {action && <div className="pt-2">{action}</div>}
  </div>
);

export default EmptyState;
